import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { KEYS_CHARCODE } from 'wix-rich-content-editor-common';
import { ListItemSelect, DropdownModal } from 'wix-rich-content-toolbars-ui';
import { s as styleInject } from '../../style-inject.es-e7b07dd7.js';
import { dividerStyleData } from '../buttons/dividerButtonsData.js';
import 'wix-rich-content-plugin-commons';
import '../../icons/SingleLineStyle.js';
import '../../icons/DoubleLineStyle.js';
import '../../icons/DashedLineStyle.js';
import '../../icons/DottedLineStyle.js';

var css_248z = ".MtqLX{box-sizing:border-box;height:29px;max-width:100%;width:100%}[dir] .MtqLX{margin:0 auto;padding-top:14px}[dir] ._86pzz{padding-top:11px}.NJAJr{stroke:currentColor;stroke-width:1;shape-rendering:crispEdges;display:block}.GcAiG,.W4eE4,._5iFws,._8RW6p{height:100%}.W4eE4{stroke-dasharray:4 4}._8RW6p{stroke-dasharray:1 5}.JNNgi,.jwWa6{width:10%}._1vK10,.mWCa-{width:40%}.VE6So{width:20%}.iNo3j{width:100%}[dir=ltr] .W-lip{margin-right:auto}[dir=rtl] .W-lip{margin-left:auto}[dir] .TESO6{margin:0 auto}[dir=ltr] .hObgW{margin-left:auto}[dir=rtl] .hObgW{margin-right:auto}.fKlOZ{width:inherit}.pNJH1{height:100%}.pNJH1 ._8VelF{height:1px}.hquZR{align-items:center;display:flex;height:38px}[dir=ltr] .hquZR{padding:0 30px 0 0!important}[dir=rtl] .hquZR{padding:0 0 0 30px!important}._4T3lR{height:18px;max-width:60px;overflow:hidden;width:60px}[dir] ._4T3lR{padding-top:7px}.Fg-jP{stroke:currentColor!important}.O4KQv{width:100%}";
var styles = {"divider-container":"MtqLX","divider-container--double":"_86pzz","divider":"NJAJr","divider--single":"GcAiG","divider--double":"_5iFws","divider--dashed":"W4eE4","divider--dotted":"_8RW6p","divider--small":"JNNgi","divider--small--mobile":"jwWa6","divider--medium":"_1vK10","divider--large--mobile":"mWCa-","divider--medium--mobile":"VE6So","divider--large":"iNo3j","divider--left":"W-lip","divider--center":"TESO6","divider--right":"hObgW","divider--fill-parent":"fKlOZ","svgFixerContainer":"pNJH1","emptyChar":"_8VelF","divider-dropdown__control":"hquZR","divider-dropdown__option":"_4T3lR","divider-dropdown__divider":"Fg-jP","divider_line_icon":"O4KQv"};
styleInject(css_248z);

const LineStylePanel = ({ getSelectedStyle, onClick, isMobile }) => {
  const { jsdomMode } = useContext(RicosContext);
  const onKeyDown = (e, commandKey) => {
    if (e.keyCode === KEYS_CHARCODE.ENTER) {
      onClick(commandKey);
      e.stopPropagation();
    }
  };
  const DropdownOptions = dividerStyleData.map(({ dataHook, icon: Icon, commandKey }) => /* @__PURE__ */ React.createElement(
    ListItemSelect,
    {
      key: commandKey,
      dataHook,
      prefix: /* @__PURE__ */ React.createElement(Icon, { className: styles.divider_line_icon, isMobile }),
      selected: commandKey === getSelectedStyle(),
      onClick: () => onClick(commandKey),
      onKeyDown: (e) => {
        onKeyDown(e, commandKey);
      }
    }
  ));
  return /* @__PURE__ */ React.createElement(DropdownModal, { options: DropdownOptions, jsdomMode });
};

export { LineStylePanel as default };
//# sourceMappingURL=LineStylePanel.js.map
